enum SignUpDriverFormStep {
  accountData = "ACCOUNT_DATA",
  userData = "USER_DATA",
  companyData = "COMPANY_DATA",
  vehicleData = "VEHICLE_DATA",
  summary = "SUMMARY",
}

export default SignUpDriverFormStep;
